import React from 'react';

const CsvImage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="374"
    height="233"
    viewBox="0 0 374 233"
  >
    <defs>
      <path
        id="a"
        d="M55.003.192L2.714 8.522a2.855 2.855 0 0 0-2.369 3.267l4.759 29.866a2.852 2.852 0 0 0 3.266 2.368l52.288-8.329a2.855 2.855 0 0 0 2.369-3.266L58.27 2.561A2.856 2.856 0 0 0 55.003.192"
      />
      <path
        id="c"
        d="M55.003.192L2.714 8.522a2.855 2.855 0 0 0-2.369 3.267l4.759 29.866a2.852 2.852 0 0 0 3.266 2.368l52.288-8.329a2.855 2.855 0 0 0 2.369-3.266L58.27 2.561A2.856 2.856 0 0 0 55.003.192"
      />
      <path
        id="e"
        d="M55.003.192L2.714 8.522a2.855 2.855 0 0 0-2.369 3.267l4.759 29.866a2.852 2.852 0 0 0 3.266 2.368l52.288-8.329a2.855 2.855 0 0 0 2.369-3.266L58.27 2.561A2.856 2.856 0 0 0 55.003.192"
      />
      <path
        id="g"
        d="M55.003.192L2.714 8.522a2.855 2.855 0 0 0-2.369 3.267l4.759 29.866a2.852 2.852 0 0 0 3.266 2.368l52.288-8.329a2.855 2.855 0 0 0 2.369-3.266L58.27 2.561A2.856 2.856 0 0 0 55.003.192"
      />
      <path
        id="i"
        d="M55.003.192L2.714 8.522a2.855 2.855 0 0 0-2.369 3.267l4.759 29.866a2.852 2.852 0 0 0 3.266 2.368l52.288-8.329a2.855 2.855 0 0 0 2.369-3.266L58.27 2.561A2.856 2.856 0 0 0 55.003.192"
      />
      <path
        id="k"
        d="M55.003.192L2.714 8.522a2.855 2.855 0 0 0-2.369 3.267l4.759 29.866a2.852 2.852 0 0 0 3.266 2.368l52.288-8.329a2.855 2.855 0 0 0 2.369-3.266L58.27 2.561A2.856 2.856 0 0 0 55.003.192"
      />
      <path
        id="m"
        d="M55.003.192L2.714 8.522a2.855 2.855 0 0 0-2.369 3.267l4.759 29.866a2.852 2.852 0 0 0 3.266 2.368l52.288-8.329a2.855 2.855 0 0 0 2.369-3.266L58.27 2.561A2.856 2.856 0 0 0 55.003.192z"
      />
      <path
        id="o"
        d="M3.155 2.533c-3.561 3.089-3.603 7.879-1.87 12.933a36.434 36.434 0 0 0 2.265 5.186c1.101 2.073 1.325 4.681.494 6.931-1.286 3.489-2.289 9.153 1.502 14.543 2.226 3.166 4.599 4.242 6.709 4.337a4.848 4.848 0 0 1 2.903 1.138c1.228 1.018 2.855 1.739 4.83 1.234 1.8-.461 3.023-1.866 3.847-3.438.556-1.057.375-4.732 1.255-5.397 1.121-.849 4.535-3.464 1-7-5.001-5-3.001-5-3.001-7 0-.979-1.692-2.958-2-4-.265-.899.625-3.885 0-5-.813-1.454-3.137-3.453-3.999-4-1.345-.852-1.12-2.722-1.614-4.455-.608-2.133-1.69-4.808-3.504-6.235C10.496 1.148 9.047.668 7.69.668c-1.697 0-3.251.752-4.535 1.865"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#DFE1E7"
        d="M371.779 206.244c12.719 9.794-68.682 2-177.881 13.6C87.321 231.166 7.427 220.966.094 205.26c-3.364-7.204 84.145-15.146 193.804-14.584 111.22.568 141.521-12.432 177.881 15.568"
      />
      <path
        fill="#F0F2F6"
        d="M295.907 203.079H67.272c-6.728 0-12.182-5.454-12.182-12.182V9.439a3.252 3.252 0 0 1 3.252-3.252h245.201a4.548 4.548 0 0 1 4.547 4.547v180.163c0 6.728-5.454 12.182-12.183 12.182"
      />
      <path
        fill="#757C99"
        d="M309.09 16.317h-254V8.571a8.57 8.57 0 0 1 8.57-8.57h237.168a8.262 8.262 0 0 1 8.262 8.26v8.056z"
      />
      <path
        fill="#F0F2F6"
        d="M67.836 8.703c0 1.202-.878 2.175-1.96 2.175-1.084 0-1.962-.973-1.962-2.175s.878-2.176 1.961-2.176c1.083 0 1.961.974 1.961 2.176"
      />
      <path
        fill="#FFEFC8"
        d="M74.7 8.703c0 1.202-.879 2.175-1.962 2.175s-1.96-.973-1.96-2.175.877-2.176 1.96-2.176S74.7 7.5 74.7 8.703"
      />
      <path
        fill="#FCC35D"
        d="M81.563 8.703c0 1.202-.878 2.175-1.961 2.175-1.083 0-1.961-.973-1.961-2.175s.878-2.176 1.96-2.176c1.084 0 1.962.974 1.962 2.176"
      />
      <path
        fill="#DFE1E7"
        d="M130.784 68.532H80.708a5.619 5.619 0 0 1-5.619-5.618V38.253a5.619 5.619 0 0 1 5.62-5.618h50.075a5.619 5.619 0 0 1 5.62 5.618v24.66a5.619 5.619 0 0 1-5.62 5.619M281.078 40.249H148.845a3.5 3.5 0 0 1-3.5-3.5v-.615a3.5 3.5 0 0 1 3.5-3.5h132.233a3.5 3.5 0 0 1 3.5 3.5v.615a3.5 3.5 0 0 1-3.5 3.5M245.311 52.215h-96.467a3.5 3.5 0 0 1-3.5-3.5V48.1c0-1.932 1.568-3.5 3.5-3.5h96.467a3.5 3.5 0 0 1 3.5 3.5v.615a3.5 3.5 0 0 1-3.5 3.5M245.311 65.268h-96.467a3.5 3.5 0 0 1-3.5-3.5v-.615a3.5 3.5 0 0 1 3.5-3.5h96.467a3.5 3.5 0 0 1 3.5 3.5v.615a3.5 3.5 0 0 1-3.5 3.5M130.784 122.922H80.708a5.62 5.62 0 0 1-5.619-5.619v-24.66a5.62 5.62 0 0 1 5.62-5.619h50.075a5.62 5.62 0 0 1 5.62 5.62v24.66a5.62 5.62 0 0 1-5.62 5.618M281.078 94.639H148.845a3.5 3.5 0 0 1-3.5-3.5v-.615a3.5 3.5 0 0 1 3.5-3.5h132.233a3.5 3.5 0 0 1 3.5 3.5v.615a3.5 3.5 0 0 1-3.5 3.5M245.311 106.605h-96.467a3.5 3.5 0 0 1-3.5-3.5v-.614a3.5 3.5 0 0 1 3.5-3.5h96.467a3.5 3.5 0 0 1 3.5 3.5v.614a3.5 3.5 0 0 1-3.5 3.5M245.311 119.659h-96.467a3.5 3.5 0 0 1-3.5-3.5v-.615c0-1.932 1.568-3.5 3.5-3.5h96.467a3.5 3.5 0 0 1 3.5 3.5v.615a3.5 3.5 0 0 1-3.5 3.5M130.784 179.488H80.708a5.62 5.62 0 0 1-5.619-5.619v-24.66a5.62 5.62 0 0 1 5.62-5.619h50.075a5.62 5.62 0 0 1 5.62 5.62v24.66a5.62 5.62 0 0 1-5.62 5.618M281.078 151.205H148.845a3.5 3.5 0 0 1-3.5-3.5v-.615a3.5 3.5 0 0 1 3.5-3.5h132.233a3.5 3.5 0 0 1 3.5 3.5v.615a3.5 3.5 0 0 1-3.5 3.5M245.311 163.17h-96.467a3.5 3.5 0 0 1-3.5-3.5v-.613a3.5 3.5 0 0 1 3.5-3.5h96.467a3.5 3.5 0 0 1 3.5 3.5v.614a3.5 3.5 0 0 1-3.5 3.5M245.311 176.225h-96.467a3.5 3.5 0 0 1-3.5-3.5v-.614a3.5 3.5 0 0 1 3.5-3.5h96.467a3.5 3.5 0 0 1 3.5 3.5v.614a3.5 3.5 0 0 1-3.5 3.5M313.09 219.832c0 6.854-21.714 12.412-48.5 12.412-11.15 0-21.427-4.23-29.613-2.582-12.824 2.582-18.887-5.83-18.887-9.83 0-6.855 22.162-6.966 48.5-12.413 27.28-5.642 48.5 5.558 48.5 12.413"
      />
      <path
        fill="#F9BA8F"
        d="M268.35 110.868c-.067-.201-5.119-3.838-8.352-8.755-3.233-4.918-6.668-11.181-6.668-11.181s2.156-5.793 1.482-6.13c-.674-.336-3.569 5.39-3.502 6.735.067 1.348 4.513 12.26 5.657 15.425 1.146 3.165 11.45 15.694 11.45 15.694l1.954-1.618-2.02-10.17z"
      />
      <path
        fill="#C6C9D5"
        d="M250.329 106.822l-55.942 8.912a7.677 7.677 0 0 1-8.79-6.373l-11.276-70.788a7.677 7.677 0 0 1 6.373-8.79l55.943-8.911a7.676 7.676 0 0 1 8.788 6.373l11.277 70.788a7.677 7.677 0 0 1-6.373 8.789"
      />
      <path
        fill="#FFF"
        d="M252.495 108.392l-55.942 8.912a7.676 7.676 0 0 1-8.788-6.373l-11.278-70.788a7.677 7.677 0 0 1 6.373-8.789l55.943-8.912a7.677 7.677 0 0 1 8.789 6.373l11.276 70.788a7.677 7.677 0 0 1-6.373 8.79"
      />
      <g>
        <g transform="translate(190 65.244)">
          <mask id="b" fill="#fff">
            <use href="#a" />
          </mask>
          <path stroke="#9EA3B7" d="M2.13 22.985l57.923-9.228" mask="url(#b)" />
        </g>
        <g transform="translate(190 65.244)">
          <mask id="d" fill="#fff">
            <use href="#c" />
          </mask>
          <path stroke="#9EA3B7" d="M3.32 30.459l57.923-9.229" mask="url(#d)" />
        </g>
        <g transform="translate(190 65.244)">
          <mask id="f" fill="#fff">
            <use href="#e" />
          </mask>
          <path
            stroke="#9EA3B7"
            d="M4.362 36.998l57.923-9.228"
            mask="url(#f)"
          />
        </g>
        <g transform="translate(190 65.244)">
          <mask id="h" fill="#fff">
            <use href="#g" />
          </mask>
          <path stroke="#9EA3B7" d="M9.633 6.941l5.655 35.501" mask="url(#h)" />
        </g>
        <g transform="translate(190 65.244)">
          <mask id="j" fill="#fff">
            <use href="#i" />
          </mask>
          <path stroke="#9EA3B7" d="M35.006 3.857l5.655 35.5" mask="url(#j)" />
        </g>
        <g transform="translate(190 65.244)">
          <mask id="l" fill="#fff">
            <use href="#k" />
          </mask>
          <path stroke="#9EA3B7" d="M46.217 2.07l5.654 35.502" mask="url(#l)" />
        </g>
        <g transform="translate(190 65.244)">
          <mask id="n" fill="#fff">
            <use href="#m" />
          </mask>
          <path
            fill="#FCC35D"
            d="M61.272 6.378L-.388 16.2-2.026 5.924l61.66-9.822z"
            mask="url(#n)"
          />
        </g>
      </g>
      <g>
        <path
          stroke="#9EA3B7"
          d="M250.658 100.937l-52.288 8.33a2.852 2.852 0 0 1-3.266-2.369l-4.76-29.866a2.854 2.854 0 0 1 2.37-3.266l52.289-8.33a2.854 2.854 0 0 1 3.266 2.37l4.758 29.865a2.853 2.853 0 0 1-2.37 3.266z"
        />
        <path
          fill="#DFE1E7"
          d="M245.804 54.444l-25.588 4.077a1.193 1.193 0 0 1-.375-2.356l25.588-4.076a1.191 1.191 0 1 1 .375 2.355M246.596 59.416l-25.588 4.077a1.193 1.193 0 0 1-.375-2.356l25.588-4.076a1.191 1.191 0 1 1 .375 2.355M214.125 59.49l-26.032 4.148a1.192 1.192 0 1 1-.375-2.355l26.03-4.147a1.191 1.191 0 1 1 .377 2.355"
        />
        <path
          fill="#757C99"
          d="M259.08 213.719s.854 2.315.365 2.864c-.487.548-5.118.365-5.178-.122-.061-.487 3.35-2.56 3.35-2.56l1.463-.182zM281.63 214.355c.244.914.487 2.56 0 2.803-.487.244-5.361-.06-5.301-.548.06-.488 3.689-2.366 3.689-2.366l1.612.111z"
        />
        <path
          fill="#47506B"
          d="M257.16 214.244l2.132.06s2.596-22.736 4.398-26.054c1.806-3.323 9.172-19.138 9.172-19.138s-1.515 12.853-.144 18.848c1.37 5.995 7.063 26.521 7.063 26.521l1.895.178s-.436-16.735-.366-23.521c.063-5.659 2.179-19.149 2.05-27.37-.032-1.641-.15-3.072-.388-4.188-.517-2.414-1.552-4.26-2.665-5.631-1.974-2.445-4.196-3.393-4.196-3.393l-14.223 1.296s-7.077 30.113-7.222 33.795c-.145 3.684 2.494 28.597 2.494 28.597"
        />
        <path
          fill="#2D344B"
          d="M274.812 155.32l-7.943 1.011 1.083 5.922 4.116 3.104 3.972-2.6zM278.65 154.663l1.865 7.879 2.845 1.226c-.032-1.641-.149-3.072-.389-4.188-.516-2.414-1.55-4.26-2.664-5.631l-1.658.714z"
        />
        <path
          fill="#FFCDAB"
          d="M262.447 111.426a5.506 5.506 0 1 0 10.962 1.054 5.506 5.506 0 0 0-10.962-1.054"
        />
        <path
          fill="#FFCDAB"
          d="M265.634 115.728l-1.847 6.656 5.31.511-.335-6.263z"
        />
        <path
          fill="#FAA918"
          d="M271.397 119.525c-1.083-.29-4.549-.65-8.954 1.516-4.404 2.167-6.562 4.793-7.076 8.52-.51 3.696 3.347 5.042 3.347 5.042s2.213 8.102 2.718 11.279c.506 3.177.361 6.21.361 6.21s0 .794 7.944.577c7.943-.216 7.221-1.877 7.221-1.877s-.29-12.637-.217-16.32c.072-3.682.29-10.254.29-10.254l-5.634-4.693z"
        />
        <path
          fill="#47506B"
          d="M267.155 104.777c2.311-2.003 5.495-2.837 8.817-.223 1.814 1.427 2.896 4.101 3.504 6.235.494 1.734.269 3.602 1.614 4.455.862.547 3.186 2.546 4 4 .624 1.115-.266 4.101 0 5 .307 1.042 2 3.021 2 4 0 2-2 2 3 7 3.535 3.535.122 6.151-1 7-.88.665-.7 4.34-1.254 5.397-.826 1.572-2.048 2.977-3.848 3.438-1.975.505-3.602-.216-4.83-1.234a4.84 4.84 0 0 0-2.903-1.138c-2.111-.095-4.483-1.17-6.709-4.337-3.791-5.39-2.787-11.054-1.501-14.543.83-2.25.606-4.858-.494-6.93a36.253 36.253 0 0 1-2.266-5.187c-1.733-5.054-1.692-9.844 1.87-12.933"
        />
      </g>
      <g transform="translate(264 102.244)">
        <mask id="p" fill="#fff">
          <use href="#o" />
        </mask>
        <path
          fill="#2D344B"
          d="M-3.892 11.484C-2.287 9.445-.91-4 2.878 10.646c.485 1.88 2.584 3.63 3.237 5.582.531 1.586 1.45 2.86 2.558 3.561.711.45 1.541 1.215 2.293 2.517.578.998-1.159 2.872-.877 3.694.554 1.613-1.73 4.73-2 5-1 1 .12 4.89 1 6 1.832 2.306 8.557 2.068 7 8-.494 1.882 6.79 3.126 6 4-.619.684-6.008.068-6.344 1.097-.499 1.528-1.319 2.93-2.664 3.49-1.477.612-2.79.054-3.826-.81-.723-.605-1.526-.889-2.334-.857-1.632.062-3.552-.776-5.54-3.578-3.386-4.77-3.104-10.139-2.417-13.494.444-2.163.046-4.586-.98-6.447a38.19 38.19 0 0 1-2.194-4.688c-1.773-4.603-2.157-9.086.318-12.229"
          mask="url(#p)"
        />
      </g>
      <g>
        <path
          fill="#FFCDAB"
          d="M261.016 122.62c1.628 1.144 5.641 8.146-.076 8.558-5.716.411-17.54-5.025-19.546-5.95-2.007-.926-12.8-10.78-12.8-10.78s-5.886-.49-6.264-1.356c-.377-.867 5.91-1.349 5.91-1.349s-1.308-2.205-.405-2.222c.904-.017 2.422 3.75 2.422 3.75s10.592 5.504 13.501 6.458c10.522 3.45 16.451 2.324 17.258 2.891"
        />
        <path
          fill="#47506B"
          d="M195.782 46.414c-.596-3.877 1.872-6.967 5.465-7.52 2.477-.38 4.212.572 5.422 1.895l-1.477 1.1c-.825-.958-2.192-1.541-3.686-1.311-2.553.393-4.212 2.7-3.776 5.537.434 2.817 2.712 4.539 5.265 4.146 1.494-.23 2.623-1.198 3.122-2.36l1.739.605c-.775 1.629-2.125 3.056-4.602 3.437-3.592.553-6.875-1.652-7.472-5.53M209.93 47.374a5.389 5.389 0 0 0 4.245 1.167c2.042-.314 2.601-1.465 2.461-2.373-.203-1.324-1.698-1.481-3.37-1.65-2.106-.218-4.54-.443-4.937-3.015-.32-2.081 1.283-3.877 3.911-4.281 1.948-.3 3.576.089 4.866 1.052l-.88 1.568c-1.123-.872-2.517-1.122-3.879-.913-1.399.216-2.253 1.082-2.09 2.14.175 1.136 1.592 1.286 3.222 1.44 2.146.233 4.646.506 5.06 3.192.302 1.966-.776 4.01-4.18 4.534-2.25.347-4.023-.214-5.283-1.24l.853-1.621zM218.04 36.524l2.157-.332 5.652 9.934 2.423-11.176 2.157-.332-3.071 13.385-2.365.364z"
        />
      </g>
    </g>
  </svg>
);

export default CsvImage;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/components/CsvImage.svg.jsx